import { every, some, words, escapeRegExp } from 'lodash';

export const friendlyMatcher = (query?: string, ...sources: string[]) =>
  some(sources, (source) =>
    every(words(query), (word) =>
      new RegExp(escapeRegExp(word), 'i').test(source),
    ),
  );
